module.exports = __webpack_public_path__ + "media/09.6903f6c9.mp3";